// btw-front/src/components/admin/dashboard/StaleBulkNoticeModal.jsx
// [관리 대상 딜] 갱신 요청 안내 일괄 발송 팝업 — 수신자별 그룹, 체크한 딜만 발송
// props 는 StaleDealsTab 의 상태/핸들러 이름을 그대로 받는다(부모 식별자와 1:1).
import React from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "antd";
import { bulkCheckboxCls, stallTone } from "./shared";

export default function StaleBulkNoticeModal({
  bulkAllSelected,
  bulkPreview,
  bulkSelected,
  bulkSelectedRecipients,
  bulkSubmitting,
  closeBulkNotice,
  confirmBulkNotice,
  days,
  toggleBulkAll,
  toggleBulkDeal,
  toggleBulkGroup,
}) {
  const { t } = useTranslation();
  return (
    <>
      {/* 일괄 발송 팝업 — 후보 딜을 수신자별로 보여주고 체크한 딜만 발송 */}
      <Modal
        title={t("admin.staleDeals.bulk.confirmTitle")}
        open={!!bulkPreview}
        width={600}
        onCancel={closeBulkNotice}
        closable={!bulkSubmitting}
        keyboard={!bulkSubmitting}
        maskClosable={!bulkSubmitting}
        footer={[
          <button
            key="cancel"
            type="button"
            onClick={closeBulkNotice}
            disabled={bulkSubmitting}
            className="btw-btn-ghost mr-2 disabled:opacity-60"
          >
            {t("admin.staleDeals.notice.confirmCancel")}
          </button>,
          <button
            key="send"
            type="button"
            onClick={confirmBulkNotice}
            disabled={bulkSubmitting || bulkSelected.size === 0}
            className="btw-btn-accent disabled:opacity-60"
          >
            {bulkSubmitting
              ? t("admin.staleDeals.notice.sending")
              : bulkSelected.size > 0
                ? t("admin.staleDeals.bulk.confirmOkCount", { n: bulkSelected.size })
                : t("admin.staleDeals.bulk.confirmOk")}
          </button>,
        ]}
      >
        {bulkPreview && (
          <div>
            <p className="text-sm text-slate-700">
              {t("admin.staleDeals.bulk.confirmSummary", {
                recipients: bulkPreview.groups.length,
                deals: bulkPreview.totalDeals,
              })}
            </p>
            <div className="mt-2 flex items-center justify-between text-xs">
              <label className="inline-flex items-center gap-1.5 text-slate-700">
                <input
                  type="checkbox"
                  className={bulkCheckboxCls}
                  checked={bulkAllSelected}
                  onChange={toggleBulkAll}
                  disabled={bulkSubmitting}
                />
                {t("admin.staleDeals.bulk.selectAll")}
              </label>
              <span className={bulkSelected.size === 0 ? "text-rose-600" : "text-slate-500"}>
                {bulkSelected.size === 0
                  ? t("admin.staleDeals.bulk.noneSelected")
                  : t("admin.staleDeals.bulk.selectedSummary", {
                      deals: bulkSelected.size,
                      recipients: bulkSelectedRecipients,
                    })}
              </span>
            </div>
            <div className="mt-2 max-h-72 overflow-y-auto rounded-lg border border-slate-200 bg-slate-50">
              {bulkPreview.groups.map((g) => {
                const ids = g.deals.map((d) => d.id);
                const checkedCount = ids.filter((id) => bulkSelected.has(id)).length;
                return (
                  <div key={g.recipientEmail} className="border-b border-slate-200 last:border-b-0">
                    <label className="flex cursor-pointer items-center gap-2 bg-white px-3 py-2 text-xs">
                      <input
                        type="checkbox"
                        className={bulkCheckboxCls}
                        checked={checkedCount === ids.length}
                        ref={(el) => {
                          if (el) el.indeterminate = checkedCount > 0 && checkedCount < ids.length;
                        }}
                        onChange={() => toggleBulkGroup(g)}
                        disabled={bulkSubmitting}
                      />
                      <span className="font-medium text-slate-800">
                        {g.recipientName || "-"} ({g.recipientEmail})
                      </span>
                      <span className="ml-auto text-slate-500">
                        {checkedCount}/{ids.length}
                      </span>
                    </label>
                    {g.deals.map((d) => (
                      <label
                        key={d.id}
                        className="flex cursor-pointer items-center gap-2 px-3 py-1.5 pl-8 text-xs text-slate-700 hover:bg-slate-100"
                      >
                        <input
                          type="checkbox"
                          className={bulkCheckboxCls}
                          checked={bulkSelected.has(d.id)}
                          onChange={() => toggleBulkDeal(d.id)}
                          disabled={bulkSubmitting}
                        />
                        <span className="min-w-0 flex-1 truncate">
                          <span className="font-medium text-slate-900">{d.projectName}</span>
                          <span className="text-slate-500"> · {d.customerCompany}</span>
                        </span>
                        <span className={`shrink-0 tabular-nums ${stallTone(d.daysSinceUpdate)}`}>
                          {t("admin.staleDeals.daysAgo", { days: d.daysSinceUpdate })}
                        </span>
                      </label>
                    ))}
                  </div>
                );
              })}
            </div>
            {(bulkPreview.skippedAlreadyNotified > 0 || bulkPreview.skippedNoRecipient > 0) && (
              <p className="mt-2 text-xs text-slate-500">
                {t("admin.staleDeals.bulk.skippedNote", {
                  already: bulkPreview.skippedAlreadyNotified,
                  noRecipient: bulkPreview.skippedNoRecipient,
                })}
              </p>
            )}
            <p className="mt-2 text-xs text-slate-500">
              {t("admin.staleDeals.notice.confirmDesc")}
            </p>
          </div>
        )}
      </Modal>
    </>
  );
}
